import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { AuthSessionService } from '../services/auth-session.service';

export const guestGuard: CanActivateFn = () => {

  const router = inject(Router);

  const authService =
    inject(AuthSessionService);

  if (authService.isTokenValid()) {

    router.navigate(['/home']);

    return false;
  }

  return true;
};